export enum ClientPost {
  ELS = 'ecologistic',
  ELSTest = 'ecologistictest',
  Koder = 'koder',
  Logistar = 'logistar',
  MyBox = 'mybox',
  BoxPost = 'boxpost',
  JonExpress = 'jonexpress',
  UPMPost = 'upmpost',
}
